export const dataTableComponentData = [
  {
    "dockDoorName": "Door 1",
    "doorUses": "Inbound Only",
    "appointmentTypes": "Live Unload, Drop Unload",
    "dockStatus": "Inactive",
    "scheduleType": "Master",
    "dateModified":"09/01/2019",
    "modifiedBy":"Pat Jones",
  },
  {
    "dockDoorName": "Door 2",
    "doorUses": "Inbound and Outbount",
    "appointmentTypes": "All Appointment Types",
    "dockStatus": "Active",
    "scheduleType": "Individual",
    "dateModified":"09/01/2019",
    "modifiedBy":"Pat Jones",
  },
  {
    "dockDoorName": "Door 3",
    "doorUses": "Inbound and Outbount",
    "appointmentTypes": "All Appointment Types",
    "dockStatus": "Inactive",
    "scheduleType": "Master",
    "dateModified":"09/01/2019",
    "modifiedBy":"Pat Jones",
  },
  {
    "dockDoorName": "Warehouse 2",
    "doorUses": "Inbound and Outbount",
    "appointmentTypes": "All Appointment Types",
    "dockStatus": "Active",
    "scheduleType": "Individual",
    "dateModified":"09/01/2019",
    "modifiedBy":"Pat Jones",
  },
  {
    "dockDoorName": "Warehouse 3",
    "doorUses": "Inbound and Outbount",
    "appointmentTypes": "Live Unload, Live Load, Drop Unload,Drop, Empty, Pickup Load",
    "dockStatus": "Inactive",
    "scheduleType": "Master",
    "dateModified":"09/01/2019",
    "modifiedBy":"Pat Jones",
  },
  {
    "dockDoorName": "Warehouse 4",
    "doorUses": "Order Shipped",
    "appointmentTypes": "Pickup Load",
    "dockStatus": "Active",
    "scheduleType": "Individual",
    "dateModified":"09/01/2019",
    "modifiedBy":"Pat Jones",
  },
  {
    "dockDoorName": "Warehouse 8",
    "doorUses": "Outbount Only",
    "appointmentTypes": "Live Unload, Drop Unload",
    "dockStatus": "Inactive",
    "scheduleType": "Individual",
    "dateModified":"SEATTLE",
    "modifiedBy":"Pat Jones",
  },
  {
    "dockDoorName": "Warehouse 9",
    "doorUses": "Inbound Only",
    "appointmentTypes": "All Appointment Types",
    "dockStatus": "Active",
    "scheduleType": "Individual",
    "dateModified":"09/01/2019",
    "modifiedBy":"Pat Jones",
  },
  {
    "dockDoorName": "Warehouse 11",
    "doorUses": "Inbound and Outbount",
    "appointmentTypes": "All Appointment Types",
    "dockStatus": "Active",
    "scheduleType": "Master",
    "dateModified":"09/01/2019",
    "modifiedBy":"Pat Jones",
  },
  {
    "dockDoorName": "Warehouse 12",
    "doorUses": "Inbound and Outbount",
    "appointmentTypes": "All Appointment Types",
    "dockStatus": "Active",
    "scheduleType": "Master",
    "dateModified":"09/01/2019",
    "modifiedBy":"Pat Jones",
  }
];

export const dataTableNewData = [
  {
    "dockDoorName": "Door 1",
    "doorUses": "Inbound Only",
    "appointmentTypes": "Live Unload, Drop Unload",
    "dockStatus": "Inactive",
    "scheduleType": "Master",
    "dateModified":"09/01/2019",
    "modifiedBy":"Pat Jones",
  },
  {
    "dockDoorName": "Door 2",
    "doorUses": "Inbound and Outbount",
    "appointmentTypes": "All Appointment Types",
    "dockStatus": "Active",
    "scheduleType": "Individual",
    "dateModified":"09/01/2019",
    "modifiedBy":"Pat Jones",
  },
];



// WEBPACK FOOTER //
// ./src/pages/dockConfigurations/html/doorLookup/stores/testData.js